import React, { useState } from "react";
import "./notification.css";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import { formatDateTime } from "../../constants/helpers/helperFunctions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { communication } from "../../constants/apis/communication";
import PopupModel from "../../commanComponents/PopupModel";
import { Modal } from "react-bootstrap";
import svgData from "../../constants/utilities/svgData";
import Loader from "../../commanComponents/Loader";
import { useNavigate } from "react-router-dom";
import { TextExpander } from "./text-expander";

export default function NotificationCard({ data, refetchList }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation((id) => communication?.markNotificationAsRead(id), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        toast.success(`Success : ${data?.data?.message}`);
        refetchList();
        queryClient.invalidateQueries(["getNotificationCount"]);
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed to update status: ${error?.message}`);
    },
  });

  const [showMenu, setShowMenu] = useState(false);

  // Close dropdown on window click
  React.useEffect(() => {
    if (!showMenu) return;
    const close = () => setShowMenu(false);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, [showMenu]);

  return (
    <div style={{ position: "relative" }}>
      {isLoading && <Loader />}
      <div
        className={`premiumNotificationCard ${!data?.isSeen ? "unread" : "read"}`}
        onClick={() => setShowMenu(false)}
      >
        {/* Left Side: Solid Dark Blue Circle with White Bell */}
        <div className="premiumNotificationIconCircle" style={{ position: "relative" }}>
          <svg viewBox="0 0 24 24" className="premiumNotificationBell">
            <path d="M18 8c0-3.3-2.7-6-6-6S6 4.7 6 8c0 7-3 9-3 9h18s-3-2-3-9z" fill="currentColor" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" fill="currentColor" />
          </svg>
          {!data?.isSeen && <span className="premiumNotificationUnreadBadge"></span>}
        </div>

        {/* Middle Side: Text and Date */}
        <div className="premiumNotificationContent">
          <h5 className="premiumNotificationCardTitle">{data?.title}</h5>
          {data?.description && <TextExpander>{data?.description}</TextExpander>}
          <span className="premiumNotificationCardTime">{formatDateTime(data?.createdAt)}</span>
        </div>

        {/* Right Side: Options Menu */}
        {!data?.isSeen && (
          <div className="premiumNotificationOptionsWrapper">
            <button
              className="premiumNotificationOptionsBtn"
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(!showMenu);
              }}
            >
              <svg viewBox="0 0 24 24" className="premiumNotificationEllipsis">
                <circle cx="12" cy="5" r="2" fill="currentColor" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
                <circle cx="12" cy="19" r="2" fill="currentColor" />
              </svg>
            </button>

            {showMenu && (
              <div className="premiumNotificationDropdown">
                <button
                  className="premiumNotificationDropdownItem"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowMenu(false);
                    mutate(data?._id);
                  }}
                >
                  <svg viewBox="0 0 24 24" className="dropdownCheckIcon" style={{ width: '16px', height: '16px', marginRight: '8px' }}>
                    <polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Mark as read
                </button>
              </div>
            )}
          </div>
        )}
      </div>

    </div>
  );
}
